<template>
  <div class="reviews-container container-fluid" role="region">
    <div class="row">
      <div class="col-xs-12">
        <div class="home-reviews-box carousel slide" data-ride="carousel" id="reviewsCarousel">
          <div class="carousel-inner" role="listbox">
            <div class="home-review item active">
              <div class="review-content">
                <div class="stars"><i class="fa fa-star">&nbsp;</i><i class="fa fa-star">&nbsp;</i><i class="fa fa-star">&nbsp;</i><i class="fa fa-star">&nbsp;</i><i class="fa fa-star">&nbsp;</i></div>
                <div class="review-text">"This is the second vehicle we have purchased from Auto Dealer in the past two years and we will continue purchase and recommend this dealership. Matthew the sales person and Mark from finance were great. Matthew was very knowlegeable of the features on my new vehicle. I am a store manager myself and I strive to provide the best customer service and these guys would be welcome employees for me. I rate them EXCELLENT!"</div>
                <div class="review-author">- John Doe</div>
              </div>
            </div>
            <div class="home-review item">
              <div class="review-content">
                <div class="stars"><i class="fa fa-star">&nbsp;</i><i class="fa fa-star">&nbsp;</i><i class="fa fa-star">&nbsp;</i><i class="fa fa-star">&nbsp;</i><i class="fa fa-star">&nbsp;</i></div>
                <div class="review-text">"We had a wonderful experience buying a new vehicle from Shaun. He was SO nice and helpful. We have bought a lot of cars over the years but this was our best experience. Thank you!"
                </div>
                <div class="review-author">- Jane Doe</div>
              </div>
            </div>
            <div class="home-review item">
              <div class="review-content">
                <div class="stars"><i class="fa fa-star">&nbsp;</i><i class="fa fa-star">&nbsp;</i><i class="fa fa-star">&nbsp;</i><i class="fa fa-star">&nbsp;</i><i class="fa fa-star">&nbsp;</i></div>
                <div class="review-text">" Best experience I've ever had trying to purchase a new car. He took his time and answered all of my questions. He was very helpful."</div>
                <div class="review-author">- Sarah Doe</div>
              </div>
            </div>
            <div class="home-review item">
              <div class="review-content">
                <div class="stars"><i class="fa fa-star">&nbsp;</i><i class="fa fa-star">&nbsp;</i><i class="fa fa-star">&nbsp;</i><i class="fa fa-star">&nbsp;</i><i class="fa fa-star">&nbsp;</i></div>
                <div class="review-text">" It was the best car buying experience I have ever had. You guys really care about your customers. "</div>
                <div class="review-author">- Jack Doe</div>
              </div>
            </div>
          </div>
          <a class="left carousel-control" href="#reviewsCarousel" role="button" data-slide="prev">
            <span class="glyphicon glyphicon-chevron-left" aria-hidden="true"></span>
            <span class="sr-only">Previous</span>
          </a>
          <a class="right carousel-control" href="#reviewsCarousel" role="button" data-slide="next">
            <span class="glyphicon glyphicon-chevron-right" aria-hidden="true"></span>
            <span class="sr-only">Next</span>
          </a>
        </div>
        <div class="text-center reviews-link"><a href="#">See All Reviews</a></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      brand: this.$store.state.chosenBrand
    };
  },
  mounted() {
    (function() {
      var s = {
        init: function() {
          var items = $('#reviewsCarousel .item'),
              heights = [],
              tallest;

          if (items.length) {
              function normalizeHeights() {
                  items.each(function() {
                      heights.push($(this).height()); 
                  });
                  tallest = Math.max.apply(null, heights);
                  items.each(function() {
                      $(this).css('min-height',tallest + 'px');
                  });
              };
              normalizeHeights();

              $(window).on('load resize orientationchange', function () {
                  tallest = 0, heights.length = 0;
                  items.each(function() {
                      $(this).css('min-height','0');
                  }); 
                  normalizeHeights();
              });
          }
        },
      };
      var c = {
        init: function() {
          $('#reviewsCarousel').carousel()
        }
      }
      $(document).ready(s.init);
      $(document).ready(c.init);
    })(jQuery);
  }
};
</script>

<style
  scoped
  src="../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"
></style>

<style scoped>
  .reviews-container {
    background: black;
    color: white;
    font-family: Helvetica, Arial, sans-serif;
  }
  .reviews-container .reviews-link {
    padding: 10px;
  }
  .reviews-container .reviews-link a {
    color: white;
    font-size: 15px;
    text-decoration: underline !important;
  }
  .home-reviews-box .home-review .review-text {
    margin-top: 15px;
    font-size: 25px;
    font-weight: 100;
  }
  .home-reviews-box .home-review .review-author {
    text-align: right;
    font-weight: 100;
    font-size: 18px;
  }
  .home-reviews-box .home-review .stars {
    padding-top: 20px;
    text-align: center;
    font-size: 30px;
    color: #F5BD05;
    background-image: none !important;
  }
  .home-reviews-box .review-content {
    max-width: 1040px;
    margin: auto;
  }
  #reviewsCarousel .carousel-control {
    width: 5%;
  }
  @media (max-width: 1199px) {
    .home-reviews-box .review-content {
      max-width: 860px;
    }
  }
  @media (max-width: 991px) {
    .home-reviews-box .review-content {
      max-width: 660px;
    }
  }
  @media (max-width: 767px) {
    .home-reviews-box .review-content {
      width: 100%;
      padding-left: 30px;
      padding-right: 30px;
      max-width: 520px;
    }
  }
</style>
